import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import Btn from "../components/Btn/Btn";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Scenery = () => {
  return (
    <React.Fragment>
      <SEO title="Scenery | ICSI 2025" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Scenery"
        content="For Participants"
        contentTwo="Scenery"
        linkage="/"

      />

      <EmptyTwo>
        {/* <div className="entry-content title-center">
          <h2>The information is to be announced. </h2>
        </div> */}
        <div className="entry-content2">
          {/* <div className="ch-lang-en">
          <Link className="btn btn-primary" to={process.env.PUBLIC_URL + "/scenery_zn"}>Chinese</Link>
          </div> */}
          <div className="space-50"></div>
          <h2>About Tokyo</h2>
          <br></br>
          <p className="font-black font-bold" align="justify">
            Tokyo, officially the Tokyo Metropolis, is the capital of Japan and one of the most populous cities in the world, with over 14 million residents as of 2023. The Greater Tokyo Area, including parts of six neighboring prefectures, is the most populous metropolitan area globally, with 41 million residents as of 2024.

            Located at the head of Tokyo Bay in the Kantō region on Honshu, Tokyo is Japan&apos;s economic center and the seat of both the Japanese government and the Emperor. The Tokyo Metropolitan Government administers Tokyo&apos;s central 23 special wards, various commuter towns and suburbs, and two outlying island chains. Since 1943, Tokyo&apos;s governing structure has been akin to a prefecture, with a Governor and Assembly overseeing the metropolis. Notable wards include Chiyoda (National Diet Building and Tokyo Imperial Palace), Shinjuku (administrative center), and Shibuya (commercial and cultural hub).

            Originally a fishing village known as Edo, Tokyo gained prominence in 1603 as the seat of the Tokugawa shogunate. By the mid-18th century, Edo was one of the world&apos;s largest cities. Following the Meiji Restoration in 1868, the imperial capital moved from Kyoto to Edo, renamed Tokyo. The city was heavily damaged by the 1923 Great Kantō earthquake and World War II bombings but underwent rapid reconstruction and expansion from the late 1940s, contributing to Japan&apos;s economic boom.

            Tokyo hosted the Summer Olympics and Paralympics in 1964 and 2021 and three G7 summits. It is an international research and development hub with major universities, including the University of Tokyo. Tokyo Station is the central hub for the Shinkansen, and Shinjuku Station is the world&apos;s busiest train station. The city is home to the world&apos;s tallest tower, Tokyo Skytree, and the oldest underground metro line in Asia-Pacific, the Tokyo Metro Ginza Line.

            In FY2021, Tokyo&apos;s nominal GDP was 113.7 trillion yen (US$1.04 trillion), accounting for 20.7% of Japan&apos;s total economic output. Including the Greater Tokyo Area, it is the second-largest metropolitan economy in the world, with a 2022 gross metropolitan product of US$2.08 trillion. Despite a decline since the 1990s, Tokyo remains a major financial hub, with the Tokyo Stock Exchange among the world&apos;s top five. Tokyo is categorized as an Alpha+ city and ranked fourth in the 2021 Global Livability Ranking and the safest city in multiple international surveys.


          </p>

          <br></br>

          <h2>About Yokohama</h2>
          <br></br>
          <p className="font-black font-bold" align="justify">
            Yokohama is the second-largest city in Japan by population and area, and the country&apos;s most populous municipality. It is the capital and most populous city in Kanagawa Prefecture, with a population of 3.7 million in 2023. Located on Tokyo Bay, south of Tokyo, in the Kantō region of Honshu, Yokohama is a major economic, cultural, and commercial hub of the Greater Tokyo Area along the Keihin Industrial Zone.

            Yokohama opened for trade with the West in 1859 following the end of Japan&apos;s policy of seclusion, and has since been known as a cosmopolitan port city. It is home to many of Japan&apos;s firsts in the Meiji period, including the first foreign trading port and Chinatown (1859), European-style sport venues (1860s), English-language newspaper (1861), confectionery and beer manufacturing (1865), daily newspaper (1870), gas-powered street lamps (1870s), railway station (1872), and power plant (1882). Yokohama developed rapidly as Japan&apos;s prominent port city after the mid-19th century and is today one of its major ports along with Kobe, Osaka, Nagoya, Fukuoka, Tokyo, and Chiba.

            Yokohama is the largest port city and high-tech industrial hub in the Greater Tokyo Area and the Kantō region. The city is home to the headquarters of companies such as Isuzu, Nissan, JVCKenwood, Keikyu, Koei Tecmo, Sotetsu, Salesforce Japan, and the Bank of Yokohama. Famous landmarks in Yokohama include Minato Mirai 21, Nippon Maru Memorial Park, Yokohama Chinatown, Motomachi Shopping Street, Yokohama Marine Tower, Yamashita Park, and Ōsanbashi Pier.


          </p>

          <br></br>

          <h3>Attractions in Tokyo and Yokohama</h3>
          <br></br>
          <li>
            <a href="#talent-park">Mount Fuji</a>
          </li>
          <li>
            <a href="#windows">Sensō-ji</a>
          </li>
          <li>
            <a href="#folk-village">Yokohama Port</a>
          </li>
          {/* <li>
            <a href="#shenzhenbay">Shenzhen Bay Park</a>
          </li> */}



          <br />
          <br />
          <h4 id="talent-park">Mount Fuji</h4>
          <p align="justify">
            Mount Fuji (富士山, Fujisan) is an active stratovolcano located on the Japanese island of Honshu, with a summit elevation of 3,776.24 meters (12,389 feet). It is the tallest mountain in Japan, the second-highest volcano located on an island in Asia (after Mount Kerinci on the Indonesian island of Sumatra), and the seventh-highest peak of an island on Earth. Mount Fuji last erupted from 1707 to 1708. The mountain is located about 100 kilometers (62 miles) southwest of Tokyo and is visible from the Japanese capital on clear days. Mount Fuji&apos;s exceptionally symmetrical cone, which is covered in snow for about five months of the year, is commonly used as a cultural icon of Japan and is frequently depicted in art and photography, as well as visited by sightseers, hikers, and mountain climbers.

            Mount Fuji is one of Japan&apos;s &quot;Three Holy Mountains&quot; (三霊山, Sanreizan) along with Mount Tate and Mount Haku. It is a Special Place of Scenic Beauty and one of Japan&apos;s Historic Sites. It was added to the World Heritage List as a Cultural Site on June 22, 2013. According to UNESCO, Mount Fuji has &quot;inspired artists and poets and been the object of pilgrimage for centuries&quot;. UNESCO recognizes 25 sites of cultural interest within the Mount Fuji locality. These 25 locations include the mountain and the Shinto shrine, Fujisan Hongū Sengen Taisha.
            <br />
            <br />
          </p>
          <p>
            <div className="title-center">
              <img
                src="./images/view/mtfuji.jpg"
                alt="talent-park"
                width="90%"
              />
            </div>
          </p>
          <br></br>
          <br></br>
          <h4 id="windows">Sensō-ji</h4>
          <p align="justify">
            Sensō-ji, also known as Asakusa Kannon Temple, is Tokyo&aops;s oldest and most significant Buddhist temple. Located in the Asakusa district, the temple is dedicated to Kannon, the Buddhist goddess of mercy and compassion. The temple&aops;s history dates back to 628 AD, making it a site rich with cultural and historical significance. Visitors enter through the iconic Kaminarimon (Thunder Gate), which leads to the bustling Nakamise-dori, a shopping street filled with traditional snacks and souvenirs.

            The main hall of Sensō-ji, known as the Hondo, is a striking example of traditional Japanese architecture and is often crowded with both tourists and locals who come to pray and seek blessings. The temple grounds also feature a beautiful five-story pagoda and various smaller shrines. Throughout the year, Sensō-ji hosts numerous festivals, the most famous being the Sanja Matsuri in May, which attracts millions of visitors. The temple&aops;s vibrant atmosphere and historical charm make it a must-visit destination in Tokyo.
          </p>
          <div className="title-center">
            <p>
              <img
                src="./images/view/senso.jpg"
                alt="windows of world"
                width="90%"
              />
              <br />
            </p>

          </div>

          <br></br>
          <br></br>

          <h4 id="folk-village">Yokohama Port</h4>
          <p align="justify">
            Yokohama Port, located in the city of Yokohama in Kanagawa Prefecture, Japan, is one of the country&apos;s major international trading ports. Established in 1859, it has played a crucial role in Japan&apos;s modernization and economic development. The port boasts state-of-the-art facilities, including container terminals, bulk cargo terminals, and passenger terminals, making it a vital hub for both commercial and passenger traffic.
            <br></br>
            <br></br>

            Over the years, Yokohama Port has expanded and modernized to keep up with global trade demands. It is well-connected by road and rail, ensuring efficient transportation of goods to and from the port. The port area also features attractions such as the Yokohama Red Brick Warehouse and Yamashita Park, making it a popular destination for tourists.
          </p>

          <div className="title-center">
            <p>
              <img src="./images/view/yokoport.jpg" alt="folk-village" width="90%" />

              <br />
            </p>

          </div>

          <br></br>
          <br></br>

          {/* <h4 id="wutong">Wutong Mountain Scenic Area </h4>
          <p align="justify">
            With an area of 31.82 square kilometres, founded in 1989 and situated in central south part of Shenzhen, Mount Wutong National Park nears the Roc Bay of South China Sea in the east, connects Hong Kong in the south, borders on Shenzhen Reservoir in the west, approaches the secondary boundaries of the pre-Shenzhen Special Economic Zone in the north.
            <br></br>
            <br></br>

            Wutong Mountain is a rare natural scenic spot in China, which is located in urban area, with coastal mountains and natural vegetations as its main scenery. There are eight scenery blocks such as &quot;Musical Instrument in Phoenix Valley&quot;, &quot;Wutong Clouds&quot;, &quot;A Phoenix Perching on the Green Wutong&quot;, &quot;East Lake Park&quot; and &quot;Fairy Lake Botanical Garden&quot; etc. In 1993 it was awarded the title of National Park of Guangdong by the Guangdong Provincial Government. In December 2009, it was conferred the title of National Park of China by the State Council.
          </p>

          <div className="title-center">
            <p>
              <img
                src="./images/shenzhen/shenzhen2.jpg"
                alt="wutong"
                width="90%"
              />
              <br />
            </p>

          </div>

          <br></br>
          <br></br>

          <h4 id="dameisha">Dameisha Beach</h4>
          <p align="justify">
            Dameisha Beach Park is one of ten tangible things promoised by the Shenzhen government. Located in Yantan District of Shenzhen, Dameisha Seashore Park embraces the Mirs Bay and owns 1,800 meters long beach. Sun Square is located in the heart of the park while Moon Square lays in the west of the park. A 432-meter long passage connects these two parks. More than 50 kinds of subtropical trees are planted in the park, including coconut tree and palm, ect.. There are many functional zones in the park, like swimming zone, sport zone, amusement zone and BBQ zone.
          </p>
          <br></br>

          <div className="title-center">
            <p>
              <img src="./images/shenzhen/shenzhen3.jpg" alt="dameisha" width="90%" />
              <br />
            </p>

          </div>
          <br></br>
          <br></br> */}

          {/* <h4 id="shenzhenbay">Shenzhen Bay Park</h4>
          <p>Shenzhen Bay Park is a seaside urban park in Shenzhen. The park occupies a 13-kilometer-long stretch of reclaimed land along the southern coast of Shenzhen on the north shore of Shenzhen Bay (Deep Bay), starting west near Shenzhen Bay Bridge at Wanghai road and ending at the Hongshulin Nature Reserve. It spans much of the coastline of the Nanshan and Futian districts. It runs along much of the length of Binhai and Binhe Boulevards and occupies an area of 108.07 hectares (267.0518 acres).

        The park is divided into two sections, namely Shenzhen Bay Coastal Recreation Zone (深圳湾滨海休闲带) at its South West side and Hongshulin Coastal Ecological Park (红树林海滨生态公园) at its Eastern side. The latter is situated within the Hongshulin Nature Reserve, a habitat of numerous endangered bird species and is also known for its mangrove.

        The entire area of the park opened on August 6, 2011, days before the 2011 Summer Universiade that took place in Shenzhen. The Hongshulin Coastal Ecological Park was opened earlier in December 2000. The entire length of the park is motor vehicle-free. Cycle paths and picnic spaces are featured along the park. The park offers a panoramic view covering the Shenzhen skyline and New Territories, Hong Kong.
          </p>
        <br></br>
        <div className="title-center">
          <p>
            <img src="./images/xian/sc8.jpg" alt="shenzhenbay" width="100%" />
            <br />
          </p>
        </div> */}

        </div>
      </EmptyTwo>
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Scenery;
